import { createAction } from 'redux-actions'

export const clearOfferDetail = createAction('CLEAR_OFFER_DETAIL')
export const clearSavingsClubOffers = createAction('CLEAR_SAVINGS_CLUB_OFFERS')
export const setCurrentPage = createAction('SET_CURRENT_PAGE')
export const setSearchCategory = createAction('SET_SEARCH_CATEGORY')
export const setSearchCriteria = createAction('SET_SEARCH_CRITERIA')
export const resetSearch = createAction('RESET_SEARCH')
